const Constants = require('EurestoFonction/Constants')
const Data = require('EurestoClass/Data')

module.exports = langue => Data.default.list(Constants.default.module.CONFIGURATION, Constants.default.donnee.langue).indexOf(langue) !== -1


// WEBPACK FOOTER //
// ./app/Utilitaire/Function/Langue.js